import { render, staticRenderFns } from "./modal-product.vue?vue&type=template&id=6a24a03a&"
import script from "./modal-product.vue?vue&type=script&lang=js&"
export * from "./modal-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports